import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  overviewsLength: 0,
  overviews: [],
  overview: {},
  overviewError: "",
  formError: "",
};

export default function OverviewReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OVERVIEW:
      return { ...state, loading: action.payload };
    case actions.LOADING_OVERVIEW_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_OVERVIEW:
      return { ...state, saveLoading: action.payload };
    case actions.GET_OVERVIEW:
      return {
        ...state,
        overviews: action.payload.overviews,
        overviewsLength: action.payload.overviewsLength,
      };
    case actions.GET_OVERVIEW_BY_ID:
      return {
        ...state, overview: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.OVERVIEW_FAIL:
      return { ...state, overviewError: action.payload };
    default:
      return state;
  }
}
